module.exports = __webpack_public_path__ + "static/media/pool1.d3ff7eab.svg";